export default {
    loading: {
        staticData: "Načítám statická data"
    },
    security: {
        login: "Přihlásit",
        username: "Uživatel",
        password: "Heslo"
    },
    operation: {
        create: "Vytvořit nový záznam",
        listOf: "Seznam {definitionName}",
        deleteSelected: "Smazat vybrané",
        deleteSelectedConfirmation: "Opravdu chcete smazat {count} vybraných záznamů?",
        deleteQueried: "Smazat všechny záznamy na základě vybraného filtru",
        deleteQueriedConfirmation: "Opravdu chcete smazat všechny záznamy, které jsou výsledky filtru?",
        exportCSV: "Exportovat všechny záznamy do CSV",
        meta: "Metadata",
        content: "Obsah",
        audit: "Auditní informace",
        cloneOperation: "Klonovat záznam",
        deleteOperation: "Smazat záznam",
        deleteOperataionConfirmation: "Opravdu chcete smazat záznam?",
        deleteSuccessTitle: "Operace byla smazána.",
        deleteSuccess: `Operation was successfully deleted`,
        deleteError: 'Chyba při ukládání operace.',
        status: {
            live: "Živý",
            draft: "Draft"
        },
        saveSuccessTitle: 'Operace byla uložena',
        saveSuccess: 'Operace {definitionId} byla úspěšně uložena',
        saveError: 'Chyba při ukládání operace.',
    },
    sidebar: {
        dashboard: "Dashboardy",
        cashflow: "Cashflow",
        reporting: "Reporty",
        operations: "Operace",
        parties: "Protistrany",
        banking: "Účty",
        market: "Tržní data",
        processing: "Processing",
        administration: "Administrace",
        loggedInAs: "Uživatel je přihlášen jako {user}",
        logout: "Odhlásit",


    },
    files: {
        filesCaption: "Nahrané soubory",
        fileName: "Název souboru",
        mimeType: "Druh souboru",
        timeStamp: "Časová známka",
        category: "Kategorie",
        customName: "Alternativní název",
        startImport: "Zahájit import",
        download: "Stáhnout",
        edit: "Editovat",
        saveSuccess: 'Soubor byl uložen.',
        saveError: 'Chyba při ukládání souboru.'
    },
    reporting: {
        definitions: 'VaR reporty',
        comparison: 'Porovnání',
        volatility: "Volatilita",
        exchangeRate: "Měnový kurz",
        currency: "Měna",
        quantile: "Spolehlivost [%]",
        gridPoint: "Grid",
        cashEventQuery: 'Cash event dotaz',
        calculate: 'Vypočítat',
        results: "Výsledky",
        result: "Výsledek",
        date: 'Datum výpočtu',
        dateFrom: 'Datum od',
        dateThru: 'Datum do',
        openPosition: 'Otevřená pozice',
        defaultParams: "Základní parametry",
        params: "Tržní data",
        calculateError: "Chyba při výpočtu VaR.",
        calculateSuccess: "Výpočet VaR byl dokončen.",
        saveSuccess: "  VaR definice byla uložena.",
        name: "Název",
        startDateExpression: "Datum od (výraz)",
        endDateExpression: "Datum do (výraz)",
        dateExpression: "Rozhodné datum (výraz)",
        limit: "Limit VaR",
        limitCurrency: "Měna limitu VaR",
        limitOP: "Limit OP",
        limitOPCurrency: "Měna limitu OP",
        limitOk: "Limit VAR ok?",
        limitOpOk: "Limit OP ok?",
        deleteResult: "Smazat výsledek",
        cashEventQueries: "Cash eventy zahrnuté",
        cashEventRemoveQueries: "Cash eventy vyjmuté",
        accountQuery: "Účty"
    },
    cashflow: {
        reports: "Reporty",
        configuration: "Nastavení",
        reportDefinitions: "Definice reportů",
        cashEventsAndEffects: "Cash eventy a efekty",
        cashEvents: "Cash eventy",
        effects: "Efekty",
        showTurnovers: "Zobraz obraty",
        reportParameters: "Parametry reportu",
        generate: "Vygeneruj report",
        plannedOperations: "Všechny plánované operace",
        accountBalances: "Všechny zůstatky",
        cashflowSum: "Cashflow zůstatek",
        balancesSum: "Účetní zůstatek",
        plannedSum: "Suma operací",
        drillDownIncludesCashEvent: "Tato buňka zahrnuje následující cash-eventy",
        definition: {
            name: "Název reportu",
            order: "Pořadí v seznamech",
            startDateExpression: "Datum od (výraz)",
            endDateExpression: "Datum do (výraz)",
            dateExpression: "Datum (výraz)",
            startMonthlyBucketsExpression: "Datum počátku měsíční granularity",
            shiftIncomeCashEvents: "Posun víkendových splatností příjmů",
            shiftOutcomeCashEvents: "Posun víkendových splatností výdajů",
            breakDateExpression: "Datum konce skutečnosti (výraz)",
            denominator: "Zobrazovat v",
            convertToReportCurrency: "Převádět částky na měnu reportu",
            reportCurrency: "Měna reportu",
            projectOperationsToBalance: "Promítat plánované operace do zůstatků",
            useBreakDateForProjection: "Používat datum konce skutečnosti",
            cashEventColumnsSetup: "Sloupce v části plánovaných operací",
            availableCashEventColumns: "Dostupné sloupce plánovaných operací",
            selectedCashEventColumns: "Vybrané sloupce plánovaných operací",
            balancesColumnsSetup: "Sloupce v části zůstatků",
            availableBalanceColumns: "Dostupné sloupce zůstatků",
            selectedBalanceColumns: "Vybrané sloupce zůstatků",
            operationQueries: "Filtry operací",
            cashEventQueries: "Filtry cash eventů",
            cashEventAdditionalFilters: "Dodatečné filtry",
            accounts: "Účty",
            currencies: "Měny",
            accountOwners: "Vlastníci účtů",
            sources: "Zdroje",
            types: "Typy",
            split: "Rozdělení reportu",
            splitDateExpression: "Datum rozdělení reportu (výraz)",
            splitCaption: "Text rozdělovače",
            categories: "Kategorie",
            effects: "Efekty",
            save: "Uložit definici",
            deleteTooltip: "Smazat definici",
            duplicateTooltip: "Duplikovat definici",
            balanceColumnNames: {
                currency: "Měna",
                accountNumber: "Číslo účtu",
                accountName: "Název účtu",
                accountOwner: "Vlastník účtu",
                accountType: "Typ účtu",
            },
            cashEventColumnNames: {
                currency: "Měna operace",
                accountCurrency: "Měna účtu",
                status: "Stav",
                account: "Účet",
                counterparty: "Protistrana",
                type: "Typ",
                source: "Zdroj",
                accountOwner: "Vlastník účtu",
                accountType: "Typ účtu",
                category: "Kategorie",
                subcategory: "Podkategorie"
            }
        }
    },
    parties: {
        parties: "Protistrany",
        partyListing: "Seznam protistran",
        creditRisk: "Kreditní riziko",
        creditRiskManagement: "Správa kreditního rizika"
    },
    banking: {
        accounts: "Účty",
        accountsList: "Seznam účtů",
        accountBalances: "Bankovní zůstatky",
        accountBalancesList: "Seznam bankovních zůstatků",
        accountBalanceItemsList: "Seznam položek zůstatků",
        accountBalancesBlotter: "Ruční zadání zůstatků",
        accountBalanceTimelines: "Časová osa zůstatků",
        reconciliation: "Rekonciliace",
        reconciledItems: "Rekonciliované položky",
        reconciliationWorkbench: "Ruční zadání rekonciliace"
    },
    interestRates: {
        saveSuccess: "Úroková míra byla uložena.",
        saveError: "Chyba při ukládání úrokové míry.",
    },
    volatilities: {
        saveSuccess: "Volatilita byla uložena.",
        saveError: "Chyba při ukládání volatility.",
    },
    market: {
        currencies: "Měny",
        currencyList: "Seznam měn",
        marketData: "Tržní data",
        exchangeRates: "Měnové kurzy",
        interestRates: "Úrokové míry",
        volatilities: "Volatility",

        tenors: "Tenors",
        validDate: 'Datum platnosti',
        term: 'Termín',
        value: 'Hodnota',
        rate: "Kurz",

        bid: "Bid",
        mid: "Mid",
        ask: "Ask"
    },
    processing: {
        processes: "Procesy",
        processesHistory: "Historie procesů",
        operationDefinitions: 'Typy operací',
        uploadedFiles: "Nahrané soubory",
        mappings: "Mapování",
        scheduling: "Plánování",
        scheduledJobs: "Naplánované úlohy",
        scripting: "Skriptování",
        scripts: "Skripty",
        importDefinitions: 'Import definic',
        icon: "Ikona",
        iconPreview: "Náhled ikony",

        triggerObjects: "Spouštěno na objektu",
        triggerActions: "Spouštěno při akci",

        deleteScript: "Smazat skript",
        executeScript: "Spustit skript",
        saveSuccessTitle: "Import definice byla uložena.",
        saveSuccessText: "Definice {defName} byla uložena."
    },
    administration: {
        operations: "Operace",
        operationDefinitions: "Definice operací",
        operationDefinitionGroups: "Kategorie definic operací",
        operationLinkDefinitions: "Definice vazeb mezi operacemi",
        cashEventGenerationScripts: "Cash event skripty",
        operationLinks: "Vazby mezi operacemi",
        security: "Zabezpečení",
        users: "Uživatelé",
        securityGroups: "Skupiny uživatelů"
    },
    dataTable: {
        newConditionalRule: "Nové pravidlo formátování",
        conditional: {
            column: "Sloupec",
            operation: "Porovnání",
            value: "Hodnota",
            bgColor: "Barva pozadí",
            fgColor: "Barva písma",
            bold: "Tučný text",
            italic: "Text kurzívou",
            underline: "Podtržení textu",
            addConditional: "Přidat pravidlo",
            gt: "Větší než",
            lt: "Menší než",
            eq: "Rovnost",
            like: "Obsahuje",
            in: "V množině hodnot"
        },
        saveLayout: "Uložit rozložení",
        resetLayout: "Obnovit rozložení",
        exportExcel: "Exportovat do Excelu",
        exportCSV: "Exportovat do CSV",
        actions: "Akce",
        selected: "Vybráno {selected} záznamů",
        showing: "Zobrazuji {actual} záznamů z celkových {total}",
        pagedBy: "stránkováno po",
        create: "Vytvořit {objectName}",
        first: "Počátek",
        last: "Konec"
    },
    searchQuery: {
        queries: "Filtrování",
        loadQuery: "Načíst filtr",
        queryName: "Název filtru",
        queryFields: "Pole filtru",
        clearQuery: "Vyčistit filtr",
        saveQuery: "Uložit filtr",
        savedQuery: "Uložené filtry",
        queryPurpose: "Popis filtru",
        locked: "Uzamčeno",
        doQuery: "Filtrovat",
        deleteQuery: "Smazat filtr",
        not: "Negace",
        inRadius: "Je v okruhu",
        isEmpty: "Je prázdný",
        range: "Je v rozsahu",
        in: "Jeden z",
        inQuery: "Jeden z poddotazu",
        expression: "Odpovídá výrazu",
        exportExcel: 'Export seznamu do Excelu',
        content: "Obsah",
        loading: "Načítám {objectName}",
        confirmDeleteQuery: "Opravdu chcete smazat filtr?"
    },
    cashEvents: {
        listOf: "Seznam cash eventů",
        auditInformation: "Auditní informace",
        refreshAudit: "Obnovit auditní informace",
        loadingReconciliation: "Načítám data o rekonciliaci",
        reconStatus: "Stav rekonciliace",
        plannedDate: "Plánované datum",
        realDate: "Skutečné datum",
        amount: "Částka",
        currency: "Měna",
        type: "Typ",
        status: "Stav",
        account: "Účet",
        counterAccount: "Protiúčet",
        source: "Zdroj",
        transactionReference: "Referenční id transakce",
        generatePayment: "Vygenerovat platbu",
        reconcile: "Provést rekonciliaci",
        reconciliationStatus: {
            notReconciled: "Nerekonciliováno",
            ambiguous: "Sporný ({count})",
            reconciled: "Rekonciliováno"
        },
        category: "Kategorie",
        subcategory: "Podkategorie"
    },
    exportExcel: 'Export do Excelu',
    detail: "Detail",
    source: "Zdroj",
    creator: "Vytvořil",
    createdTimestamp: "Časová značka vytvoření",
    updatedBy: "Upravil",
    updatedTimestamp: "Časová značka úpravy",
    securityGroup: "Skupina uživatelů",
    save: "Uložit",
    saveAll: "Uložit vše",
    refresh: "Obnovit",
    yes: "Ano",
    no: "Ne",
    confirm: "Potvrdit",
    cancel: "Zrušit",
    name: "Název",
    systemName: "Systémový název",
    displayName: "Zobrazený název",
    status: "Stav",
    invalidDate: "Neplatné datum",
    unsaved: "Neuloženo",
    date: "Datum",
    objects: 'Objekty',
    confirmPlease: "Prosím potvrďte",
    description: "Popis",
    code: "Kód",
    enableSoftDelete: "Povolit zneplatnění",
    enableUpdates: "Povolit aktualizaci",
    enableDrafts: "Povolit návrh",
    parameters: "Parametry",
    parameter: "Parametr",
    saveParameter: "Uložit parametr",
    type: "Typ",
    required: "Povinné",
    allowInvalidInput: "Povolit neplatný vstup",

    removeParameter: "Smazat parametr",
    editParameter: "Editovat parametr",
    propertyType: "Typ parametru",

    maxLength: "Maximální délka",
    regularExpression: "Regulární výraz",
    precision: "Přesnost",
    minValue: "Minimální hodnota",
    maxValue: "Maximální hodnota",
    entityType: "Typ entity",
    enumValues: "Výčtové hodnoty",

    editation: "Editace",
    inlineHelp: "Nápověda",

    notValidInput: "Nevalidní výraz",

    gridPoints: 'Intervaly',
    gridPoint: 'Interval',

    term: 'Délka',
    curves: 'Křivky',
    exchangeRate: "Měnový kurz",

    savingVol: "uložení volatility",
    savingIR: "uložení urokové míry",
    thousands: "Tisíce",
    millions: "Miliony",
    ones: "Jednotky",
    noShift: "Bez posunu",
    mondayShift: "Posun na pondělí",
    fridayShift: "Posun na pátek",
    nearShift: "Posun na nejbližší prac. den",
    category: "Kategorie",
    subcategory: "Podkategorie",
    exportInterval: "Rozsah exportu",
    startExport: "Exportovat",
    dateFrom: "Datum od",
    dateThru: "Datum do",
    exportSuccess: "Export do excelu byl dokončen.",
    exportError: "Chyba při exportování do excelu.",

    users: {
        objectName: "uživatele",
        detailName: "Uživatel",
        username: 'Uživatelské jméno',
        email: "Email",
        role: "Role",
        password: "Heslo",
        defaultSecGroup: 'Defaultní uživatelská skupina',
        blocked: "Blokovaný",
        active: "Aktivní",
        reasonBlocked: "Důvod blokace",
        secGroupAccesses: "Přístupy uživatelských skupin",
        resetPassword: "Resetovat heslo",
        operator: "Operátor",
        manager: "Manažer",
        resetSuccess: "Heslo bylo úspěšně změněno.",
        savingUser: "uložení uživatele",
        read: "ČTENÍ",
        allRead: "VŠE ČTENÍ",
        write: "ZÁPIS",
        allWrite: "VŠE ZÁPIS",
        forbidden: "ZAKÁZÁNÉ",
        allForbidden: "VŠE ZAKÁZÁNÉ",

    },

    securityGroups: {
        objectName: 'skupinu uživatelů'
    },

    operationDefinition: {
        objectName: "Definice operace",
        saveSuccessTitle: "Kategorie definic operací byla uložena.",
        saveSuccess: "Kategorie definic operací byla úspěšně  uložena.",
        delete: "Smazat definici operace.",
        clone: "Kopie definice operace.",
    },
    search: {
        searchResults: "Výsledky hledání",
        availableActions: "Dostupné akce"
    },
    accounts: {
        accounts: "Účty",
        account: "Účet",
        name: "Název účtu",
        alias: "Alias účtu",
        eBankingName: "Název účtu v bankovnictví",
        number: "Číslo účtu",
        internal: "Interní",
        bank: "Banka",
        type: "Typ účtu",
        currency: "Měna účtu",
        iban: "IBAN",
        location: "Lokace",
        active: "Aktivní",
        lastBalanceDate: "Poslední datum zůstatku",
        actualBalance: "Aktuální zůstatek",
        owner: "Vlastník",
        owerdraftLimit: "Povolený kontokorent",
        visualizationColor: "Barva",
        securityGroup: "Skupina uživatelů",
        balanceDate: 'Datum zůstatku',
        actualDate: "Datum",
        savingAccount: "uložení účtu"
    },
    accountBalances: {
        accountBalances: "Zůstatky účtů",
        accountBalance: "Zůstatek účtu",
        startBalance: "Počátek zůstatku",
        endBalance: "Konec zůstatku",
    },
    accountBalancesItems: {
        accountBalancesItems: "Položky zůstatku účtu",
        accountBalancesItem: "Položka zůstatku účtu",
        amount: "Množství",
        variableSymbol: "Variabilní symbol",
        specificSymbol: "Specifický symbol",
        counterAccount: "Protiúčet",
        counterAccountName: "Protiúčet název",
        counterAccountBankCode: "Protiúčet kód banky",
        message: "Zpráva",
    },

    accountBalancesBlotter: {
        accountBalancesBlotter: "Ruční zadání zůstatků",
        toDate: "Účty se zůstatky k datu"
    },

    accountBalancesTimelines: {
        accountBalancesTimelines: "Časové osy zůstatků",
        dateInterval: "Interval",
        dateFrom: "Datum od",
        dateThru: "Datum do",
        aditionalAttributes: "Rozšiřující atributy",
        color: "Barva účtu",
        showInactive: "Zobrazit neaktivní účty",
        applyFilter: "Aplikovat filtr",
        transpose: "Transponovat",
    },

    reconciliation: {
        reconciliation: "Rekonciliace",
        reconciliationItems: "Rekonciliované položky",
        operation: "Operace",
        originalDate: "Originální datum",
        plannedDate: "Plánované datum",
        realizationDate: "Datum realizace",
        transactionReference: "Reference",
        manual: "Manuální",
        automatic: "Automatický",
        cashEvent: "Ruční zadaní rekonciliace",
        counterparty: 'Protistrana',

    },
    comparison: {
        cardLabel: 'Název',
        createNew: 'Vytvořit nový',
        expression: 'Výraz',
        expressionValue: 'Výsledek',
        addNewSearchQuery: 'Přidat filtr',
        removeFilter: 'Odebrat filtr',
        run: 'Spustit',
        operationDefinition: 'Typ operace',
        filter: 'Filtr',
        filterLabel: 'Filtr {index}',
        editFilter: 'Upravit filtr',
        operator: 'Operátor',
        list: 'Seznam',
        calculateError: "Chyba při výpočtu.",
        calculateComplete: "Výpočet byl dokončen.",
        calculateStart: "Výpočet byl zahájen.",
        loading: "Načítám",
        emptyName: "Není vyplněn název u filtru.",
        emptyExpression: "Není vyplněn výraz.",
        searchQuerySaveError: "Chyba při ukládání filtru.",
        searchQuerySaveComplete: "Filtr {name} byl uložen.",
        operationNotSelected: "Na kartě {cardName} není vybraný typ operace.",
        attributeNotSelected: "Na kartě {cardName} není vybraný atribut.",
        noFilters: "Na kartě {cardName} není vyplněný filtr.",

    },

    processingData : "Vyčkejte prosím, zpracovávám požadavek"
}
